import React from 'react'

const viewEntry = ({ heading, value }) => {
    return (
        <div style={styles.profile}>
            <p style={styles.headingStyle}>{heading}</p>
            <p style={styles.valueStyle}>{value}</p>
        </div>
    )
}

const styles = {
    profile: {
        display:'flex',
        width: "100%",
        marginBottom: 5, 
        backgroundColor: "#eee",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        maxWidth:'100%',
        overflowX:'hidden'
    },
    headingStyle: {
        width: "40%",
    },
    valueStyle: {
        width: "60%"
    }
}

export default viewEntry;